import { Image } from "antd";
import "./style.scss";

const ImageSlide = ({ imageList }) => (
  <Image.PreviewGroup className="image-slider" items={imageList}>
    <Image width={200} src={imageList[0]} />
  </Image.PreviewGroup>
);

export default ImageSlide;
